import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { tv } from "tailwind-variants";

const styles = tv({
  slots: {
    base: "flex flex-row items-center gap-30 border-b border-secondary-light px-30 py-20",
    icon: "h-25 w-25",
  },
});

interface IProps {
  url: string;
  title: string;
  external: boolean;
  newTab: boolean;
  icon: IconProp;
  closeMenu: () => void;
}

const MobileSidebarLink = ({
  url,
  title,
  external,
  newTab,
  icon,
  closeMenu,
}: IProps) => {
  const { base, icon: iconStyles } = styles();

  if (external) {
    return (
      <a
        className={base()}
        target={newTab ? "_blank" : "_self"}
        onClick={closeMenu}>
        <FontAwesomeIcon fixedWidth icon={icon} className={iconStyles()} />
        {title}
      </a>
    );
  }

  return (
    <Link to={url} className={base()} onClick={closeMenu}>
      <FontAwesomeIcon fixedWidth icon={icon} className={iconStyles()} />
      {title}
    </Link>
  );
};

export default MobileSidebarLink;
